module.exports = __webpack_public_path__ + "img/hazel.916556a0.svg";